export const placementDefs = {
  featured: 1,
  slider: 2,
  side: 3,
  background: 4,
  header_logo: 5,
};
